@if (maintenance()) {
  <div class="w-screen h-screen flex justify-center items-center">
    <div class="">
      <div class="text-center flex justify-center">
        <img src="logo.png" class="logo !h-auto w-24">
      </div>
      <div class="text-3xl font-thin">
        Coming soon...
      </div>
    </div>

  </div>
} @else {
  <router-outlet></router-outlet>
  <wun-toast />
  @if (showSpinner()) {
    <wun-spinner />
  }
}


<wun-drawer [(opened)]="showCart" position="right">
  <wun-cart />
</wun-drawer>
